

import React, { FC } from 'react';
import { Project } from '@brg/api';
import PU from '../../../helpers/utils/ProjectUtils';
import { FInter, FlexBox } from '@brg/ui';
import CoordsDisplay from '../../../helpers/utils/CoordsDisplay';
import { ProfileUtils } from 'core/auth';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CreateLinkTo } from '../../../constants/linkTo';
import { bURL } from '../../../../core';
import { LayoutConst } from 'core/modules';

export const MoreProjects = styled(FlexBox)`
    width: 1152px;
    margin: 0 auto;
    flex-direction: column;

    color: #ffffff;
    div {
        align-items: flex-end;
        letter-spacing: -0.02em;

        color: #ffffff;
        display: inline;
    }

    a {
        display: inline;
        opacity: 0.47;
        cursor: pointer;

        &:hover {
            text-decoration: none;
            color: #fefefe;
            opacity: 0.73;
        }
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 940px;
    }

    @media (max-width: 960px) {
        width: 100%;

        h2 {
            font-family: Inter;
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            margin-bottom: 24px;

            align-items: flex-start;
            letter-spacing: -0.02em;

            margin-left: 14px;

            color: #ffffff;
            display: flex;
            flex-direction: column;

            span {
                display: inline;
                opacity: 0.47;
                cursor: pointer;

                &:hover {
                    color: #fefefe;
                    opacity: 0.73;
                }
            }
        }
    }
`;

export const PSMoreTitle: FC<{ project: Project }> = ({ project }) => {
    const { t } = useTranslation();
    return (
        <MoreProjects className={'white_theme_moreProjects'}>
            {PU.isMultipleAuthors(project) ? (
                <FInter.SectionTitle>
                    {t('more_projects_at')}&nbsp;
                    <a
                        href={CreateLinkTo.explore(
                            bURL.saveVariablesToURIComponent({
                                display: 'map',
                                coords: {
                                    longitude: project.point?.longitude ?? 0,
                                    latitude: project.point?.latitude ?? 0,
                                },
                                zoom: 15,
                                dp: 1,
                            }),
                        )}
                    >
                        {CoordsDisplay.fromPoint(project.point ?? ({ latitude: 0, longitude: 0 } as any))}
                    </a>
                </FInter.SectionTitle>
            ) : (
                <FInter.SectionTitle>
                    {t('more_projects_by')}&nbsp;
                    <a href={CreateLinkTo.designerNew(project.author)}>
                        {ProfileUtils.getFullNameString(project.author)}
                    </a>
                </FInter.SectionTitle>
            )}
        </MoreProjects>
    );
};


import React, { FC } from 'react';
import { Project } from '@brg/api';
import PU from '../../../helpers/utils/ProjectUtils';
import { FInter, FlexBox } from '@brg/ui';
import CoordsDisplay from '../../../helpers/utils/CoordsDisplay';
import { ProfileUtils } from 'core/auth';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CreateLinkTo } from '../../../constants/linkTo';
import { bURL } from '../../../../core';
import { LayoutConst } from 'core/modules';

export const MoreProjects = styled(FlexBox)`
    width: 1152px;
    margin: 0 auto;
    flex-direction: column;

    color: #ffffff;
    div {
        align-items: flex-end;
        letter-spacing: -0.02em;

        color: #ffffff;
        display: inline;
    }

    a {
        display: inline;
        opacity: 0.47;
        cursor: pointer;

        &:hover {
            text-decoration: none;
            color: #fefefe;
            opacity: 0.73;
        }
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        width: 940px;
    }

    @media (max-width: 960px) {
        width: 100%;

        h2 {
            font-family: Inter;
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 24px;
            margin-bottom: 24px;

            align-items: flex-start;
            letter-spacing: -0.02em;

            margin-left: 14px;

            color: #ffffff;
            display: flex;
            flex-direction: column;

            span {
                display: inline;
                opacity: 0.47;
                cursor: pointer;

                &:hover {
                    color: #fefefe;
                    opacity: 0.73;
                }
            }
        }
    }
`;

export const PSMoreTitle: FC<{ project: Project }> = ({ project }) => {
    const { t } = useTranslation();
    return (
        <MoreProjects className={'white_theme_moreProjects'}>
            {PU.isMultipleAuthors(project) ? (
                <FInter.SectionTitle>
                    {t('more_projects_at')}&nbsp;
                    <a
                        href={CreateLinkTo.explore(
                            bURL.saveVariablesToURIComponent({
                                display: 'map',
                                coords: {
                                    longitude: project.point?.longitude ?? 0,
                                    latitude: project.point?.latitude ?? 0,
                                },
                                zoom: 15,
                                dp: 1,
                            }),
                        )}
                    >
                        {CoordsDisplay.fromPoint(project.point ?? ({ latitude: 0, longitude: 0 } as any))}
                    </a>
                </FInter.SectionTitle>
            ) : (
                <FInter.SectionTitle>
                    {t('more_projects_by')}&nbsp;
                    <a href={CreateLinkTo.designerNew(project.author)}>
                        {ProfileUtils.getFullNameString(project.author)}
                    </a>
                </FInter.SectionTitle>
            )}
        </MoreProjects>
    );
};
